webpackJsonp([1],{

/***/ 1187:
/*!*************************************************************************!*\
  !*** ./src/containers/widget/components/Steps/FormCreator/Templates.js ***!
  \*************************************************************************/
/*! exports provided: initial, template1, template2, template3 */
/*! exports used: initial, template1, template2, template3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return template1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return template2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return template3; });
var initial = {
    fieldToEdit: '',
    title: "Form title",
    description: "Form description",
    type: "object",
    required: [],
    properties: {},
    uiSchema: {}
};

var template1 = {
    "fieldToEdit": "",
    "title": "Form title",
    "description": "Form description",
    "type": "object",
    "required": [],
    "properties": {
        "d21262a6-f941-49a6-9717-087bebbb570e": {
            "id": "d21262a6-f941-49a6-9717-087bebbb570e",
            "title": "Subject",
            "type": "string",
            "isRequired": false,
            "rows": 1,
            "enumType": "dropdown",
            "minimum": 0,
            "maximum": 0,
            "default": ""
        },
        "d2bbd209-c896-4bf8-9a8d-ec2c88b9a297": {
            "id": "d2bbd209-c896-4bf8-9a8d-ec2c88b9a297",
            "title": "Message",
            "type": "string",
            "isRequired": false,
            "rows": "4",
            "enumType": "dropdown",
            "minimum": 0,
            "maximum": 0,
            "default": ""
        }
    },
    "uiSchema": {
        "d2bbd209-c896-4bf8-9a8d-ec2c88b9a297": {
            "ui:widget": "textarea",
            "ui:options": {
                "rows": 4
            }
        }
    }
};
var template2 = {
    "fieldToEdit": "",
    "title": "Form title",
    "description": "Form description",
    "type": "object",
    "required": [],
    "properties": {
        "d21262a6-f941-49a6-9717-087bebbb570e": {
            "id": "d21262a6-f941-49a6-9717-087bebbb570e",
            "title": "Subject",
            "type": "string",
            "isRequired": false,
            "rows": 1,
            "enumType": "dropdown",
            "minimum": 0,
            "maximum": 0,
            "default": ""
        }
    },
    "uiSchema": {
        "d2bbd209-c896-4bf8-9a8d-ec2c88b9a297": {
            "ui:widget": "textarea",
            "ui:options": {
                "rows": 4
            }
        }
    }
};

var template3 = {
    "fieldToEdit": "",
    "title": "Form title",
    "description": "Form description",
    "type": "object",
    "required": [],
    "properties": {
        "d2bbd209-c896-4bf8-9a8d-ec2c88b9a297": {
            "id": "d2bbd209-c896-4bf8-9a8d-ec2c88b9a297",
            "title": "Message",
            "type": "string",
            "isRequired": false,
            "rows": "4",
            "enumType": "dropdown",
            "minimum": 0,
            "maximum": 0,
            "default": ""
        }
    },
    "uiSchema": {
        "d2bbd209-c896-4bf8-9a8d-ec2c88b9a297": {
            "ui:widget": "textarea",
            "ui:options": {
                "rows": 4
            }
        }
    }
};

/***/ }),

/***/ 1188:
/*!**********************************************************************!*\
  !*** ./src/containers/widget/components/Steps/FormBuilderJQStart.js ***!
  \**********************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(/*! jquery */ 264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core__ = __webpack_require__(/*! @material-ui/core */ 66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__(/*! sweetalert2 */ 1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






window.jQuery = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;
window.$ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;

__webpack_require__(/*! jquery-ui-sortable */ 1190);
__webpack_require__(/*! formBuilder */ 553);
__webpack_require__(/*! formBuilder/dist/form-render.min.js */ 1191);
__webpack_require__(/*! formBuilder/dist/form-builder.min.js */ 553);

// const options = {
//     defaultFields: [{
//         "type": "header",
//         "subtype": "h1",
//         "label": "Header"
//     },
//     {
//         "type": "text",
//         "label": "Subject",
//         "className": "form-control",
//         "name": "text-1568543650327",
//         "subtype": "text"
//     },
//     {
//         "type": "textarea",
//         "label": "Message",
//         "className": "form-control",
//         "name": "textarea-1568543651609",
//         "subtype": "textarea",
//         "rows": 4
//     }],
//     disabledActionButtons: ['data', 'save'],
//     disableFields: ['button', 'file', 'hidden'],
//     disabledAttrs: ['name', 'className', 'required', 'access', 'value', 'step'],
//     typeUserDisabledAttrs: {
//         'textarea': [
//             'subtype'
//         ],
//         'text': [
//             'subtype'
//         ],
//         'paragraph': [
//             'subtype'
//         ],
//     },
//     stickyControls: {
//         enable: true
//     },
// }


var FormBuilderJQStart = function (_Component) {
    _inherits(FormBuilderJQStart, _Component);

    function FormBuilderJQStart() {
        _classCallCheck(this, FormBuilderJQStart);

        return _possibleConstructorReturn(this, (FormBuilderJQStart.__proto__ || Object.getPrototypeOf(FormBuilderJQStart)).apply(this, arguments));
    }

    _createClass(FormBuilderJQStart, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _props = this.props,
                handleNext = _props.handleNext,
                formJq = _props.formJq;

            var deff = [{
                "type": "header",
                "subtype": "h1",
                "label": "Header"
            }, {
                "type": "text",
                "label": "Subject",
                "className": "form-control",
                "name": "text-1568543650327",
                "subtype": "text"
            }, {
                "type": "textarea",
                "label": "Message",
                "className": "form-control",
                "name": "textarea-1568543651609",
                "subtype": "textarea",
                "rows": 4
            }];
            if (formJq) {
                deff = formJq;
            }

            var options = {
                defaultFields: deff,
                disabledActionButtons: ['data', 'save'],
                disableFields: ['button', 'file', 'hidden'],
                disabledAttrs: ['name', 'className', 'required', 'access', 'value', 'step', 'other'],
                typeUserDisabledAttrs: {
                    'textarea': ['subtype'],
                    'text': ['subtype'],
                    'paragraph': ['subtype']
                },
                stickyControls: {
                    enable: true
                }
            };

            var fbEditor = document.getElementById('fb-editor');
            var formBuilder = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(fbEditor).formBuilder(options);

            // document.getElementById('getJSON').addEventListener('click', function () {
            //     console.log(formBuilder.actions.getData('json', true));
            // });

            document.getElementById('next').addEventListener('click', function () {
                // const data = formBuilder.actions.getData('json', true)
                for (var index = 0; index < document.getElementsByClassName('option-value').length; index++) {
                    document.getElementsByClassName('option-value')[index].value = document.getElementsByClassName('option-label')[index].value;
                }
                var data = formBuilder.actions.getData();
                var flag = false;
                var list = ['text', 'number', 'autocomplete', 'checkbox-group', 'number', 'textarea', 'select', 'radio-group', 'date'];
                for (var _index = 0; _index < data.length; _index++) {
                    var element = data[_index];
                    if (list.includes(element.type)) {
                        flag = true;
                        break;
                    }
                }
                if (flag === true) {
                    handleNext(data);
                } else {
                    __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                        text: 'Oops! Looks like you forgot to add an input field for your form'
                    });
                }
            });
        }
    }, {
        key: "render",
        value: function render() {
            var handleBack = this.props.handleBack;

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { className: "builderjq-wrapper" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "div",
                        { className: "jq-form" },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("form", { id: "fb-editor" })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "div",
                        { className: "jqBuilder-button-container" },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_2__material_ui_core__["a" /* Button */],
                            {
                                onClick: handleBack,
                                variant: "outlined",
                                color: "primary"
                            },
                            "Back"
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_2__material_ui_core__["a" /* Button */],
                            {
                                id: "next",
                                variant: "contained",
                                color: "primary"
                            },
                            "next"
                        )
                    )
                )
            );
        }
    }]);

    return FormBuilderJQStart;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FormBuilderJQStart);

/***/ }),

/***/ 1203:
/*!****************************!*\
  !*** ./src/redux/store.js ***!
  \****************************/
/*! exports provided: store */
/*! exports used: store */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(/*! redux */ 117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers__ = __webpack_require__(/*! ./reducers */ 1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__middlewares_index__ = __webpack_require__(/*! ./middlewares/index */ 1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__ = __webpack_require__(/*! react-redux-i18n */ 312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_observable__ = __webpack_require__(/*! redux-observable */ 1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie__ = __webpack_require__(/*! js-cookie */ 1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_ajax__ = __webpack_require__(/*! rxjs/ajax */ 1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_build_url__ = __webpack_require__(/*! build-url */ 1516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_build_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_build_url__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }










var ajaxWithXSRF = function ajaxWithXSRF(method) {
    return function (url, body, queryParams) {
        return Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_ajax__["a" /* ajax */])({
            url: __WEBPACK_IMPORTED_MODULE_7_build_url___default()(url, { queryParams: method === 'GET' ? body : queryParams }),
            method: method,
            crossDomain: true,
            headers: {
                'Content-Type': 'application/json',
                'X-XSRF-TOKEN': __WEBPACK_IMPORTED_MODULE_5_js_cookie___default.a.get('XSRF-TOKEN')
            },
            body: method === 'GET' ? undefined : body
        });
    };
};

var epicMiddleware = Object(__WEBPACK_IMPORTED_MODULE_4_redux_observable__["a" /* createEpicMiddleware */])({
    dependencies: {
        sendPost: ajaxWithXSRF('POST'),
        sendPut: ajaxWithXSRF('PUT'),
        sendGet: ajaxWithXSRF('GET')
    }
});

// export const store = compose(applyMiddleware(...middlewares, epicMiddleware))(createStore)(combineReducers(reducers));

var store = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* compose */])(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */].apply(undefined, _toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__middlewares_index__["a" /* default */]).concat([epicMiddleware])))(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])(__WEBPACK_IMPORTED_MODULE_1__reducers__["a" /* default */]), window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

Object(__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__["syncTranslationWithStore"])(store);
store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux_i18n__["setLocale"])('en'));

/***/ }),

/***/ 1204:
/*!*******************************!*\
  !*** ./src/redux/reducers.js ***!
  \*******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_app_AppReducer__ = __webpack_require__(/*! ../containers/app/AppReducer */ 1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_widget_WidgetReducer__ = __webpack_require__(/*! ../containers/widget/WidgetReducer */ 1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_login_LoginReducer__ = __webpack_require__(/*! ../containers/login/LoginReducer */ 1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(/*! redux-form */ 1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__ = __webpack_require__(/*! react-redux-i18n */ 312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__);






/* harmony default export */ __webpack_exports__["a"] = ({
    widgetReducer: __WEBPACK_IMPORTED_MODULE_1__containers_widget_WidgetReducer__["a" /* default */],
    app: __WEBPACK_IMPORTED_MODULE_0__containers_app_AppReducer__["a" /* default */],
    form: __WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* reducer */],
    user: __WEBPACK_IMPORTED_MODULE_2__containers_login_LoginReducer__["a" /* default */],
    i18n: __WEBPACK_IMPORTED_MODULE_4_react_redux_i18n__["i18nReducer"]
});

/***/ }),

/***/ 1205:
/*!******************************************!*\
  !*** ./src/containers/app/AppReducer.js ***!
  \******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppActions__ = __webpack_require__(/*! ./AppActions */ 359);


var INITIAL_STATE = {
  page: '',
  snackBar: '',
  loading: false,
  loadingBackDrop: false,
  leftDrawer: false,
  enablePremium: false,
  enableDomainSSO: false,
  mainElement: null,
  env: '',
  stripe: {}
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__AppActions__["b" /* GET_TEST_MESSAGE_START */]:
      return Object.assign({}, state, { testFetching: true });
    case __WEBPACK_IMPORTED_MODULE_0__AppActions__["a" /* GET_TEST_MESSAGE */]:
      if (action.error) {
        return Object.assign({}, state, { error: action.payload.message, testFetching: false });
      }
      return Object.assign({}, state, action.payload.data, { fetching: false });
  }
  return state;
});

/***/ }),

/***/ 1206:
/*!************************************************!*\
  !*** ./src/containers/widget/WidgetReducer.js ***!
  \************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WidgetActions__ = __webpack_require__(/*! ./WidgetActions */ 1207);


var INITIAL_STATE = {};

/* harmony default export */ __webpack_exports__["a"] = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__WidgetActions__["b" /* SEND_API_MESSAGE_START */]:
            return Object.assign({}, state, { apiFetching: true });
        case __WEBPACK_IMPORTED_MODULE_0__WidgetActions__["a" /* SEND_API_MESSAGE */]:
            if (action.error) {
                return Object.assign({}, state, { error: action.payload.message, apiFetching: false });
            }
            return Object.assign({}, state, action.payload.data, { fetching: false });
    }
    return state;
});

/***/ }),

/***/ 1207:
/*!************************************************!*\
  !*** ./src/containers/widget/WidgetActions.js ***!
  \************************************************/
/*! exports provided: SEND_API_MESSAGE_START, SEND_API_MESSAGE, sendMessage */
/*! exports used: SEND_API_MESSAGE, SEND_API_MESSAGE_START */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SEND_API_MESSAGE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SEND_API_MESSAGE; });
/* unused harmony export sendMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var SEND_API_MESSAGE_START = 'SEND_API_MESSAGE_START';
var SEND_API_MESSAGE = 'SEND_API_MESSAGE';

var sendMessage = function sendMessage(body) {
    return function (dispatch) {
        dispatch({ type: SEND_API_MESSAGE_START });

        var payload = __WEBPACK_IMPORTED_MODULE_0_axios__["post"]('/api/send', body);
        dispatch({
            type: SEND_API_MESSAGE,
            payload: payload
        });
    };
};

/***/ }),

/***/ 1208:
/*!**********************************************!*\
  !*** ./src/containers/login/LoginReducer.js ***!
  \**********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LoginActions__ = __webpack_require__(/*! ./LoginActions */ 224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_optional_js__ = __webpack_require__(/*! optional-js */ 1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_optional_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_optional_js__);



var INITIAL_STATE = {
    isLogin: false,
    fetching: true,
    loggingIn: false,
    signingUp: false,
    sendingEmail: false,
    restoringPass: false,
    email: '',
    error: '',
    justLoggedOut: true,
    sessionExpired: false
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__LoginActions__["f" /* LOGIN_START */]:
            return Object.assign({}, state, { loggingIn: true, error: '' });
        case __WEBPACK_IMPORTED_MODULE_0__LoginActions__["e" /* LOGIN */]:
            if (action.error) {
                var error = __WEBPACK_IMPORTED_MODULE_1_optional_js__["of"](action).map(function (action) {
                    return action.payload;
                }).map(function (payload) {
                    return payload.response;
                }).map(function (response) {
                    return response.data;
                }).map(function (data) {
                    return data.custom_message;
                }).orElse('Something went wrong. Please try again later.');
                // noinspection JSUnresolvedVariable
                var domainIsNotWhitelisted = error === "Current domain is not available for login";

                return Object.assign({}, state, {
                    isLogin: false,
                    loggingIn: false,
                    error: error,
                    domainIsNotWhitelisted: domainIsNotWhitelisted
                });
            }
            return Object.assign({}, state, {
                loggingIn: false,
                isLogin: true,
                loginSuccess: true,
                sessionExpired: false,
                loginMessage: "Signup",
                userName: action.payload.userName,
                domainIsNotWhitelisted: false
            });
        case __WEBPACK_IMPORTED_MODULE_0__LoginActions__["d" /* IDENTITY_START */]:
            return Object.assign({}, state, { fetching: true, justLoggedOut: false });
        case __WEBPACK_IMPORTED_MODULE_0__LoginActions__["c" /* IDENTITY */]:
            if (action.error) {
                return Object.assign({}, state, { fetching: false, isLogin: false, justLoggedOut: false });
            }
            return Object.assign({}, state, {
                fetching: false,
                isLogin: true
            }, action.payload.data);
        case __WEBPACK_IMPORTED_MODULE_0__LoginActions__["g" /* LOGOUT */]:
            if (action.error) {
                return Object.assign({}, state, { fetching: false, error: action.error, justLoggedOut: true });
            }
            return Object.assign({}, state, { fetching: false, isLogin: false, userName: '' });
        case __WEBPACK_IMPORTED_MODULE_0__LoginActions__["b" /* GET_USER_LOGIN_STATUS_START */]:
            return Object.assign({}, state, { fetching: true });
        case __WEBPACK_IMPORTED_MODULE_0__LoginActions__["a" /* GET_USER_LOGIN_STATUS */]:
            if (action.error) {
                return Object.assign({}, INITIAL_STATE, { fetching: false });
            }
            return Object.assign({}, state, action.payload.data, { isLogin: true, fetching: false });
        case __WEBPACK_IMPORTED_MODULE_0__LoginActions__["h" /* SESSION_EXPIRED */]:
            if (state.sessionExpired) {
                return state;
            }
            return Object.assign({}, state, { fetching: false, isLogin: false, justLoggedOut: true, sessionExpired: true });
    }
    return state;
});

/***/ }),

/***/ 1377:
/*!*******************************************!*\
  !*** ./locale-data/complete.js (ignored) ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1382:
/*!****************************************!*\
  !*** ./src/redux/middlewares/index.js ***!
  \****************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Firewall__ = __webpack_require__(/*! ./Firewall */ 1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_logger__ = __webpack_require__(/*! redux-logger */ 1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_promise__ = __webpack_require__(/*! redux-promise */ 1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_thunk__ = __webpack_require__(/*! redux-thunk */ 1391);





var logger = Object(__WEBPACK_IMPORTED_MODULE_1_redux_logger__["createLogger"])();

/* harmony default export */ __webpack_exports__["a"] = ([__WEBPACK_IMPORTED_MODULE_3_redux_thunk__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_redux_promise___default.a, __WEBPACK_IMPORTED_MODULE_0__Firewall__["a" /* default */], logger]);

/***/ }),

/***/ 1383:
/*!*******************************************!*\
  !*** ./src/redux/middlewares/Firewall.js ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_login_LoginActions__ = __webpack_require__(/*! ../../containers/login/LoginActions */ 224);



var HTTP_STATUS_UNAUTHORIZED = 401;
/* harmony default export */ __webpack_exports__["a"] = (function (store) {
    return function (next) {
        return function (action) {
            if (action.payload && action.error && action.payload.response && action.payload.response.status === HTTP_STATUS_UNAUTHORIZED) {
                store.dispatch(__WEBPACK_IMPORTED_MODULE_0__containers_login_LoginActions__["j" /* sessionExpired */]());
            }
            return next(action);
        };
    };
});

/***/ }),

/***/ 224:
/*!**********************************************!*\
  !*** ./src/containers/login/LoginActions.js ***!
  \**********************************************/
/*! exports provided: LOGIN_START, LOGIN, login, LOGOUT, logout, IDENTITY_START, IDENTITY, identityCheck, GET_USER_LOGIN_STATUS_START, GET_USER_LOGIN_STATUS, getUserLoginStatus, SESSION_EXPIRED, sessionExpired, EXECUTE_RECAPTCHA_START, EXECUTE_RECAPTCHA, executeRecaptcha */
/*! exports used: GET_USER_LOGIN_STATUS, GET_USER_LOGIN_STATUS_START, IDENTITY, IDENTITY_START, LOGIN, LOGIN_START, LOGOUT, SESSION_EXPIRED, identityCheck, sessionExpired */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOGIN_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOGIN; });
/* unused harmony export login */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOGOUT; });
/* unused harmony export logout */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IDENTITY_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IDENTITY; });
/* harmony export (immutable) */ __webpack_exports__["i"] = identityCheck;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_USER_LOGIN_STATUS_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_USER_LOGIN_STATUS; });
/* unused harmony export getUserLoginStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SESSION_EXPIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return sessionExpired; });
/* unused harmony export EXECUTE_RECAPTCHA_START */
/* unused harmony export EXECUTE_RECAPTCHA */
/* unused harmony export executeRecaptcha */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var LOGIN_START = "LOGIN_START";
var LOGIN = "LOGIN";

function login(_ref) {
    var email = _ref.email,
        password = _ref.password;

    return function (dispatch) {
        dispatch({
            type: LOGIN_START
        });
        var formData = new FormData();
        formData.append("email", email);
        formData.append("password", password);

        var payload = __WEBPACK_IMPORTED_MODULE_0_axios__["post"]('/auth/login', formData);

        dispatch({
            type: LOGIN,
            payload: payload
        });
    };
}

var LOGOUT = "LOGOUT";

function logout() {
    return function (dispatch) {
        __WEBPACK_IMPORTED_MODULE_0_axios__["get"]("/auth/logout").then(function () {
            dispatch({
                type: LOGOUT
            });
        }, function (error) {
            dispatch({
                type: LOGOUT,
                payload: { error: error }
            });
        });
    };
}

var IDENTITY_START = "IDENTITY_START";
var IDENTITY = "IDENTITY";

function identityCheck() {
    return function (dispatch) {
        dispatch({
            type: IDENTITY_START
        });

        var payload = __WEBPACK_IMPORTED_MODULE_0_axios__["get"]("/api/account/identity");
        dispatch({
            type: IDENTITY,
            payload: payload
        });
    };
}

var GET_USER_LOGIN_STATUS_START = "GET_USER_LOGIN_STATUS_START";
var GET_USER_LOGIN_STATUS = "GET_USER_LOGIN_STATUS";

var getUserLoginStatus = function getUserLoginStatus() {
    return function (dispatch) {
        dispatch({ type: GET_USER_LOGIN_STATUS_START });

        var payload = __WEBPACK_IMPORTED_MODULE_0_axios__["get"]('/api/auth-status');
        dispatch({
            type: GET_USER_LOGIN_STATUS,
            payload: payload
        });
    };
};

var SESSION_EXPIRED = "SESSION_EXPIRED";

var sessionExpired = function sessionExpired() {
    return { type: SESSION_EXPIRED };
};

var EXECUTE_RECAPTCHA_START = "EXECUTE_RECAPTCHA_START";
var EXECUTE_RECAPTCHA = "EXECUTE_RECAPTCHA";

var executeRecaptcha = function executeRecaptcha(instance) {
    return function (dispatch) {
        dispatch({ type: EXECUTE_RECAPTCHA_START });
        instance.execute();

        var payload = __WEBPACK_IMPORTED_MODULE_0_axios__["post"]("/api/verify-recaptcha?response=" + instance.getResponse() + "&secret=" + instance.props.sitekey);
        dispatch({
            type: EXECUTE_RECAPTCHA,
            payload: payload
        });
    };
};

/***/ }),

/***/ 359:
/*!******************************************!*\
  !*** ./src/containers/app/AppActions.js ***!
  \******************************************/
/*! exports provided: GET_TEST_MESSAGE_START, GET_TEST_MESSAGE, getTestMessage */
/*! exports used: GET_TEST_MESSAGE, GET_TEST_MESSAGE_START, getTestMessage */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_TEST_MESSAGE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_TEST_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTestMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var GET_TEST_MESSAGE_START = 'GET_TEST_MESSAGE_START';
var GET_TEST_MESSAGE = 'GET_TEST_MESSAGE';

var getTestMessage = function getTestMessage() {
    return function (dispatch) {
        dispatch({ type: GET_TEST_MESSAGE_START });

        var payload = __WEBPACK_IMPORTED_MODULE_0_axios__["get"]('/api/test1');
        dispatch({
            type: GET_TEST_MESSAGE,
            payload: payload
        });
    };
};

/***/ }),

/***/ 554:
/*!**************************************!*\
  !*** ./src/assets/images/myicon.png ***!
  \**************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 628:
/*!************************!*\
  !*** multi ./entry.js ***!
  \************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /Users/thomas/Developer/widget-editor-client/entry.js */629);


/***/ }),

/***/ 629:
/*!******************!*\
  !*** ./entry.js ***!
  \******************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(/*! react-dom */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_Main__ = __webpack_require__(/*! ./src/Main */ 634);
/* eslint-disable import/default */




Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__src_Main__["a" /* default */], null), document.getElementById('app'));

/***/ }),

/***/ 634:
/*!*********************!*\
  !*** ./src/Main.js ***!
  \*********************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(/*! react-router-dom */ 635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(/*! react-redux */ 47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(/*! react-router */ 670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes_main__ = __webpack_require__(/*! ./routes/main */ 671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom_es_Redirect__ = __webpack_require__(/*! react-router-dom/es/Redirect */ 338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_store__ = __webpack_require__(/*! ./redux/store */ 1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_helmet__ = __webpack_require__(/*! react-helmet */ 1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_myicon_png__ = __webpack_require__(/*! ./assets/images/myicon.png */ 554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_myicon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_myicon_png__);











var routes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* Switch */],
    null,
    __WEBPACK_IMPORTED_MODULE_4__routes_main__["a" /* default */].map(function (prop, key) {
        if (prop.redirect) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom_es_Redirect__["a" /* default */], { from: prop.path, to: prop.to, key: key });
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: prop.path, component: prop.component,
            exact: prop.exact, key: key });
    })
);

var Main = function Main() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */],
        { store: __WEBPACK_IMPORTED_MODULE_6__redux_store__["a" /* store */] },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_helmet__["Helmet"],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta', { name: 'robots', content: 'nofollow' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('link', { rel: 'icon', type: 'image/png', href: 'assets/images/myicon.png' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* BrowserRouter */],
                null,
                routes
            )
        )
    );
};

/* harmony default export */ __webpack_exports__["a"] = (Main);

/***/ }),

/***/ 671:
/*!*****************************!*\
  !*** ./src/routes/main.jsx ***!
  \*****************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_app_App__ = __webpack_require__(/*! ../containers/app/App */ 672);


/* harmony default export */ __webpack_exports__["a"] = ([{
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_0__containers_app_App__["a" /* default */]
}]);

/***/ }),

/***/ 672:
/*!***********************************!*\
  !*** ./src/containers/app/App.js ***!
  \***********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(/*! react-redux */ 47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__login_LoginActions__ = __webpack_require__(/*! ../login/LoginActions */ 224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(/*! redux */ 117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AppActions__ = __webpack_require__(/*! ./AppActions */ 359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_app_scss__ = __webpack_require__(/*! ../../assets/app.scss */ 691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_app_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__widget_components_Main__ = __webpack_require__(/*! ../widget/components/Main */ 692);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






// import Test2 from '../widget/components/test2';



function inIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

var App = function (_React$Component) {
    _inherits(App, _React$Component);

    function App() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, App);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = App.__proto__ || Object.getPrototypeOf(App)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            mobileOpen: false
        }, _this.componentDidUpdate = function () {
            var _this$props = _this.props,
                setMainElement = _this$props.setMainElement,
                mainElement = _this$props.app.mainElement;

            if (!mainElement && _this.mainElement) {
                setMainElement(_this.mainElement);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(App, [{
        key: "componentWillMount",
        value: function componentWillMount() {
            var _props = this.props,
                identityCheck = _props.identityCheck,
                history = _props.history,
                routeChanged = _props.routeChanged;

            identityCheck();
            // history.listen((nextLocation, action) => {
            //     this.props.location.pathname !== nextLocation.pathname && routeChanged();
            // });
        }
    }, {
        key: "componentWillUpdate",
        value: function componentWillUpdate(_ref2) {
            var user = _ref2.user;

            if (inIframe() && !user.fetching && !user.isLogin) {
                console.warn("isIframe", inIframe());
            } else {
                console.warn("isLogin", user.isLogin);
            }
        }
    }, {
        key: "render",
        value: function render() {
            // const {app, user, classes, handleSubmit, brand, location} = this.props;

            // if (!user.fetching && !user.isLogin) {
            //     return <button onClick={this.sendMessageToParent}>Authorize</button>
            // }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__widget_components_Main__["a" /* default */], null);
            // return <Test2 />;
        }
    }]);

    return App;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapStateToProps = function mapStateToProps(_ref3) {
    var user = _ref3.user,
        app = _ref3.app,
        brand = _ref3.brand;
    return { user: user, app: app, brand: brand };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
        identityCheck: __WEBPACK_IMPORTED_MODULE_2__login_LoginActions__["i" /* identityCheck */],
        getTestMessage: __WEBPACK_IMPORTED_MODULE_4__AppActions__["c" /* getTestMessage */]
    }, dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(App));

/***/ }),

/***/ 691:
/*!*****************************!*\
  !*** ./src/assets/app.scss ***!
  \*****************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 692:
/*!**************************************************!*\
  !*** ./src/containers/widget/components/Main.js ***!
  \**************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(/*! react-redux */ 47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(/*! axios */ 99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Stepper__ = __webpack_require__(/*! ./Stepper */ 693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Steps_Step1__ = __webpack_require__(/*! ./Steps/Step1 */ 913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Steps_Step2__ = __webpack_require__(/*! ./Steps/Step2 */ 920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Steps_Step3__ = __webpack_require__(/*! ./Steps/Step3 */ 945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Steps_FormCreator__ = __webpack_require__(/*! ./Steps/FormCreator */ 946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Steps_FormBuilderJQStart__ = __webpack_require__(/*! ./Steps/FormBuilderJQStart */ 1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core__ = __webpack_require__(/*! @material-ui/core */ 66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_responsive_modal__ = __webpack_require__(/*! react-responsive-modal */ 1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_copy_to_clipboard__ = __webpack_require__(/*! react-copy-to-clipboard */ 1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_copy_to_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_copy_to_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_myicon_png__ = __webpack_require__(/*! ../../../assets/images/myicon.png */ 554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_myicon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_myicon_png__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// import Modal from 'react-modal';






// import FormBuilderJQ from './Steps/FormBuilderJQ';

// import FormBuilderJQFinish from './Steps/FormBuilderJQFinish';









var Main = function (_Component) {
    _inherits(Main, _Component);

    function Main() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Main);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Main.__proto__ || Object.getPrototypeOf(Main)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            activeStep: 0,
            isLoggedIn: false,
            groupNameToStore: '',
            selectedGroup: null,
            createGroupName: '',
            errorMessage: '',
            widget: '',
            groupMailbox: '',
            selectType: '0',
            show: false,
            deliveryMethod: '1',
            form: null,

            formJq: null,
            fieldsCount: 0
        }, _this.handleSelectTypeChange = function (e) {
            _this.resetErrorMessage();
            var selectType = e.target.value;
            if (selectType !== _this.state.selectType) {
                _this.setState({ selectType: selectType });
            }
        }, _this.handleSelectTypeByClick = function (selectType) {
            _this.resetErrorMessage();
            if (selectType !== _this.state.selectType) {
                _this.setState({ selectType: selectType });
            }
        }, _this.resetErrorMessage = function () {
            if (_this.state.errorMessage.trim()) {
                _this.setState({ errorMessage: '' });
            }
        }, _this.handleSetErrorMessage = function (errorMessage) {
            _this.setState({ errorMessage: errorMessage });
        }, _this.handleSetCreateGroupName = function (createGroupName) {
            if (createGroupName && createGroupName.trim()) {
                _this.setState({ createGroupName: createGroupName });
            }
        }, _this.handleNext = function () {
            var activeStep = _this.state.activeStep;

            _this.setState({ activeStep: activeStep + 1 });
        }, _this.handleBack = function () {
            _this.resetErrorMessage();
            // this.setState({ selectedGroup: null, createGroupName: '' })
            _this.setState(function (state) {
                return { activeStep: state.activeStep - 1 };
            });
        }, _this.handleGroupSelect = function (data) {
            _this.setState({ selectedGroup: data });
            _this.resetErrorMessage();
        }, _this.BackFromWidget = function () {
            sessionStorage.setItem('widget-resp', '');
            sessionStorage.setItem('group-mail-box', '');
            _this.setState({ widget: '', activeStep: 1 });
        }, _this.onStep2Click = function (selectType, createGroupRef) {
            var selectedGroup = _this.state.selectedGroup;

            if (selectType === '0') {
                if (selectedGroup && selectedGroup.id) {
                    _this.resetErrorMessage();
                    _this.handleNext();
                } else {
                    _this.setState({ errorMessage: 'Please select group' });
                }
            } else {
                if (createGroupRef.trim()) {
                    _this.handleSetCreateGroupName(createGroupRef);
                    _this.handleNext();
                } else {
                    // handleSetErrorMessage('Please enter group name');
                    _this.setState({ errorMessage: 'Please enter group name' });
                }
            }
        }, _this.handleGroupSend = function (usersUrlInput) {
            var data = _this.state.selectedGroup;
            console.log(data);
            _this.setState({ groupNameToStore: data.groupName });
            sessionStorage.setItem('group-name', data.groupName);
            if (usersUrlInput && usersUrlInput.trim()) {
                _this.resetErrorMessage();
                data.domain = usersUrlInput;
                data.widgetType = parseInt(_this.state.deliveryMethod);
                // data.formSchema = this.state.form
                data.formSchema = _this.state.formJq;
                console.log(data);
                __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/widget/create', data).then(function (resp) {
                    console.log(resp);
                    sessionStorage.setItem('widget-resp', resp.data.widgetText);
                    sessionStorage.setItem('group-mail-box', resp.data.group_mailbox);
                    _this.setState({ widget: resp.data.widgetText, groupMailbox: resp.data.group_mailbox });
                    _this.showModal(usersUrlInput);
                }).catch(function (err) {
                    _this.setState({ errorMessage: err.message });
                    console.log(err);
                });
            } else {
                _this.setState({ errorMessage: 'Enter Domain Please' });
            }
        }, _this.onCreateWidget = function (usersUrlInput) {
            if (!_this.state.widget) {
                if (_this.state.selectType === "0") {
                    _this.handleGroupSend(usersUrlInput);
                } else {
                    _this.onCreateGroupHandler(usersUrlInput);
                }
            } else {
                _this.showModal(usersUrlInput);
            }
        }, _this.onCreateGroupHandler = function (usersUrlInput) {
            if (usersUrlInput.trim()) {
                var email = _this.props.user.email;

                console.log(email);
                console.log(usersUrlInput);
                _this.setState({ groupNameToStore: _this.state.createGroupName });
                var data = {
                    email: email,
                    domain: usersUrlInput,
                    groupName: _this.state.createGroupName,
                    widgetType: parseInt(_this.state.deliveryMethod),
                    // formSchema: this.state.form
                    formSchema: _this.state.formJq
                };
                console.log(data);
                __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/api/widget/create', data).then(function (resp) {
                    console.log(resp);
                    sessionStorage.setItem('widget-resp', resp.data.widgetText);
                    sessionStorage.setItem('group-mail-box', resp.data.group_mailbox);
                    sessionStorage.setItem('group-name', _this.state.createGroupName);
                    _this.setState({ widget: resp.data.widgetText, groupMailbox: resp.data.group_mailbox });
                    _this.showModal(usersUrlInput);
                }).catch(function (err) {
                    _this.setState({ errorMessage: err.message });
                    console.log(err);
                });
            } else {
                _this.setState({ errorMessage: 'Enter Domain Please' });
            }
        }, _this.showModal = function (usersUrlInput) {
            if (usersUrlInput.trim()) {
                _this.setState({
                    show: !_this.state.show,
                    usersUrl: usersUrlInput
                });
            } else {
                _this.setState({ errorMessage: 'You must enter url in order to get widget' });
            }
        }, _this.handleCloseModal = function () {
            _this.setState({ show: false });
        }, _this.formCreatorClick = function (form) {
            _this.setState({ form: form });
            _this.handleNext();
        }, _this.handeNextFromFormBuilderJQ = function (form) {
            // console.log(form)
            _this.setState({ formJq: form });
            _this.handleNext();
        }, _this.renderStep = function () {
            var _this$state = _this.state,
                activeStep = _this$state.activeStep,
                selectType = _this$state.selectType,
                deliveryMethod = _this$state.deliveryMethod;

            switch (activeStep) {
                case 0:
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Steps_Step1__["a" /* default */], null);
                case 1:
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Steps_Step2__["a" /* default */], {
                        onStep2Click: _this.onStep2Click,
                        handleGroupSelect: _this.handleGroupSelect,
                        handleSelectTypeChange: _this.handleSelectTypeChange,
                        handleSelectTypeByClick: _this.handleSelectTypeByClick,
                        selectType: selectType,
                        selectedGroup: _this.state.selectedGroup,
                        createGroupName: _this.state.createGroupName
                    });
                case 2:
                    return (
                        // <FormCreator handleNext={this.formCreatorClick} />
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Steps_FormBuilderJQStart__["a" /* default */], {
                            handleNext: _this.handeNextFromFormBuilderJQ,
                            handleBack: _this.handleBack,
                            formJq: _this.state.formJq
                        })
                    );
                case 3:
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Steps_Step3__["a" /* default */], {
                        BackFromWidget: _this.BackFromWidget,
                        handleBack: _this.handleBack,
                        onCreateWidget: _this.onCreateWidget,

                        widget: _this.state.widget,
                        onShowWidget: function onShowWidget() {
                            return _this.setState({ show: true });
                        },
                        focused: _this.resetErrorMessage,

                        deliveryMethod: deliveryMethod,
                        handleDeliveryMethodChange: _this.handleDeliveryMethodChange
                    })
                    // <FormBuilderJQFinish 
                    // handleBack={this.handleBack}
                    // formJq={this.state.formJq}
                    // />
                    ;

                default:
                    return null;
            }
        }, _this.handleFocus = function (event) {
            return event.target.select();
        }, _this.setFavicon = function (favicon, name) {
            var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.type = 'image/png';
            link.rel = 'icon';
            link.href = favicon;
            document.getElementsByTagName('head')[0].appendChild(link);
        }, _this.handleDeliveryMethodChange = function (e) {
            _this.resetErrorMessage();
            var deliveryMethod = e.target.value;
            if (deliveryMethod !== _this.state.deliveryMethod) {
                _this.setState({ deliveryMethod: deliveryMethod });
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Main, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setFavicon(__WEBPACK_IMPORTED_MODULE_12__assets_images_myicon_png___default.a);

            var widgetIdFromLocalStorage = sessionStorage.getItem('widget-resp') || '';
            var groupMailBoxFromLocalStorage = sessionStorage.getItem('group-mail-box') || '';
            var groupNameFromLocalStorage = sessionStorage.getItem('group-name') || '';

            this.setState({
                widget: widgetIdFromLocalStorage,
                groupMailbox: groupMailBoxFromLocalStorage,
                groupNameToStore: groupNameFromLocalStorage
            });
            if (widgetIdFromLocalStorage != '') {
                this.setState({ activeStep: 3 });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var user = this.props.user;
            var activeStep = this.state.activeStep;

            if (prevProps.user.isLogin !== user.isLogin && user.isLogin && activeStep == 0) {
                this.handleNext();
            }
        }

        // handleBack = () => {
        //     this.resetErrorMessage();
        //     this.setState({ selectedGroup: null, createGroupName: '' })
        //     this.setState(state => ({ activeStep: state.activeStep - 1 }));
        // }

    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                activeStep = _state.activeStep,
                errorMessage = _state.errorMessage;

            if (this.props.user.fetching) return null;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'app-wrapper' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'root' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Stepper__["a" /* default */], { activeStep: activeStep }),
                    errorMessage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* Typography */],
                        { style: { color: 'red' } },
                        errorMessage
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'step-wrapper' },
                        this.renderStep()
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_react_responsive_modal__["a" /* default */],
                    {
                        open: this.state.show,
                        onClose: this.handleCloseModal,
                        styles: rModalStyles
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* Typography */],
                                { variant: 'body2' },
                                'The email address allocated for group "',
                                this.state.groupNameToStore,
                                '" is:'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* Typography */],
                                { variant: 'subtitle2', className: 'modal-typography' },
                                ' ',
                                this.state.groupMailbox
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_9__material_ui_core__["t" /* Typography */],
                                { variant: 'body2', style: {
                                        maxWidth: 555,
                                        marginBottom: 25
                                    } },
                                'Based on what you selected we have customized your Widget embed code below. Copy this code to your website where you would like the Widget to appear:'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', {
                            onFocus: this.handleFocus,
                            className: 'text-area-test',
                            name: 'Text1',
                            cols: '42',
                            rows: '12',
                            defaultValue: this.state.widget
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            {
                                className: 'modal-btn-container'
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_9__material_ui_core__["a" /* Button */],
                                {
                                    style: {
                                        marginTop: '70px',
                                        width: '156px',
                                        display: 'flex'
                                    },
                                    className: 'step2-button-container',
                                    onClick: this.handleCloseModal,
                                    variant: 'outlined',
                                    color: 'primary'
                                },
                                'Close'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_11_react_copy_to_clipboard__["CopyToClipboard"],
                                { text: this.state.widget },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_9__material_ui_core__["a" /* Button */],
                                    { style: {
                                            marginTop: '70px',
                                            width: '156px',
                                            display: 'flex'
                                        },
                                        variant: 'outlined',
                                        color: 'primary'
                                    },
                                    'Copy'
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Main;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var rModalStyles = {
    modal: {
        top: '20%',
        padding: '40px'
    }
};

var mapStateToProps = function mapStateToProps(_ref2) {
    var user = _ref2.user;
    return { user: user };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Main));

/***/ }),

/***/ 693:
/*!*****************************************************!*\
  !*** ./src/containers/widget/components/Stepper.js ***!
  \*****************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(/*! @material-ui/core */ 66);



/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
    var activeStep = _ref.activeStep;

    var steps = ["Sign In", "Select Group", "Form Builder", "Create"];
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["s" /* Stepper */],
        { activeStep: activeStep, style: { marginBottom: 50 } },
        steps.map(function (label) {
            var stepProps = {};
            var labelProps = {};
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["q" /* Step */],
                Object.assign({ key: label }, stepProps),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["r" /* StepLabel */],
                    labelProps,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["t" /* Typography */],
                        { component: 'span', style: { fontWeight: 600, marginRight: 5 } },
                        label
                    )
                )
            );
        })
    );
});

/***/ }),

/***/ 913:
/*!*********************************************************!*\
  !*** ./src/containers/widget/components/Steps/Step1.js ***!
  \*********************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(/*! @material-ui/core */ 66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_urlUtils__ = __webpack_require__(/*! ../../../../utils/urlUtils */ 914);




/* harmony default export */ __webpack_exports__["a"] = (function () {

    var Authorize = function Authorize() {
        window.location.href = __WEBPACK_IMPORTED_MODULE_2__utils_urlUtils__["a" /* transferSearchQueryParams */](window.location.search, '/auth/login', ['x-frames-allow-from', 'token']);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { display: 'flex', alignItems: 'center', flexDirection: 'column' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["f" /* Fade */],
                { 'in': true, timeout: 600 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["t" /* Typography */],
                    { variant: 'h5' },
                    'Messaging Bridge - Widget Setup'
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { padding: '50px 0' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["h" /* Grow */],
                { 'in': true, timeout: 900 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["t" /* Typography */],
                    { component: 'div', className: 'main-text' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Blix Messaging Bridge allows your team to communicate directly with your website visitors with or without the need for them to disclose their private email addresses. You can add a Widget to your website now and begin handling your customer feedback with ease, providing superior analysis, distribution and response. It\u2019s very simple to add the Blix Messaging Bridge Widget to your website and start getting the feedback you always wanted.'
                    )
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["a" /* Button */],
            {
                onClick: Authorize,
                variant: 'contained',
                color: 'primary',
                style: {
                    flexShrink: 0,
                    width: '50%',
                    borderRadius: 7
                }
            },
            'Sign In'
        )
    );
});

/***/ }),

/***/ 914:
/*!*******************************!*\
  !*** ./src/utils/urlUtils.js ***!
  \*******************************/
/*! exports provided: transferSearchQueryParams, transferUrlQueryParams */
/*! exports used: transferSearchQueryParams */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = transferSearchQueryParams;
/* unused harmony export transferUrlQueryParams */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(/*! query-string */ 915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);


/**
 * @param baseSearchPath - querystring part of a URL needed to parse (Example: window.location.search for client apps)
 * @param targetPath - target path
 * @param queryParamsArrayToTransfer - query params that need's to be transferred
 * @returns {string} result url
 */
function transferSearchQueryParams(baseSearchPath, targetPath, queryParamsArrayToTransfer) {
    var parsedBase = __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(baseSearchPath);
    var queryParamsDict = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = queryParamsArrayToTransfer[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var queryParam = _step.value;

            var currentQueryValue = parsedBase[queryParam];
            if (currentQueryValue) {
                queryParamsDict[queryParam] = currentQueryValue;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringifyUrl({ url: targetPath, query: queryParamsDict });
}

/**
 * @param baseUrlPath -  entire URL needed to parse (Example: window.location.href for client apps)
 * @param targetPath - target path
 * @param queryParamsArrayToTransfer - query params that need's to be transferred
 * @returns {string} result url
 */
function transferUrlQueryParams(baseUrlPath, targetPath, queryParamsArrayToTransfer) {
    var parsedBase = __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parseUrl(baseUrlPath);
    var queryParamsDict = {};
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = queryParamsArrayToTransfer[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var queryParam = _step2.value;

            var currentQueryValue = parsedBase.query[queryParam];
            if (currentQueryValue) {
                queryParamsDict[queryParam] = currentQueryValue;
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    return __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringifyUrl({ url: targetPath, query: queryParamsDict });
}

/***/ }),

/***/ 920:
/*!*********************************************************!*\
  !*** ./src/containers/widget/components/Steps/Step2.js ***!
  \*********************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(/*! @material-ui/core */ 66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TestSelect4__ = __webpack_require__(/*! ../TestSelect4 */ 921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(/*! react-redux */ 47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(/*! axios */ 99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Step2 = function (_Component) {
    _inherits(Step2, _Component);

    function Step2() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Step2);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Step2.__proto__ || Object.getPrototypeOf(Step2)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            groups: [],
            getGroupsErrorMessage: '',
            groupsFetching: true
        }, _this.componentDidMount = function () {
            var email = _this.props.user.email;


            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('/api/groups?email=' + email).then(function (resp) {
                console.log(resp);
                _this.setState({ groups: resp.data.groups });
            }).catch(function (err) {
                console.log(err);
                _this.setState({ getGroupsErrorMessage: err.response.data.error });
            }).finally(function () {
                _this.setState({ groupsFetching: false });
                if (_this.state.groups.length <= 0) {
                    _this.props.handleSelectTypeByClick("1");
                }
            });
        }, _this.logoutHandler = function () {
            window.location.href = '/auth/logout';
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Step2, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                handleGroupSelect = _props.handleGroupSelect,
                onStep2Click = _props.onStep2Click,
                selectType = _props.selectType,
                handleSelectTypeChange = _props.handleSelectTypeChange,
                handleSelectTypeByClick = _props.handleSelectTypeByClick;
            var _props2 = this.props,
                selectedGroup = _props2.selectedGroup,
                createGroupName = _props2.createGroupName;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'step2-wrapper ' },
                !this.state.groupsFetching ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                    null,
                    !this.state.getGroupsErrorMessage ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["t" /* Typography */],
                                { style: { textAlign: 'center' }, variant: 'h5', className: 'title-text' },
                                'Messaging Bridge - Widget Setup'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { flexGrow: 1 } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: { marginTop: 50 }, onClick: function onClick() {
                                        return handleSelectTypeByClick("0");
                                    } },
                                this.state.groups.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["g" /* FormControlLabel */], {
                                        control: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["o" /* Radio */], {
                                            value: '0',
                                            color: 'primary',
                                            onChange: handleSelectTypeChange,
                                            checked: selectType === "0"
                                        }),
                                        label: 'Select an existing Team / Channel'
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TestSelect4__["a" /* default */], {
                                        onGroupSend: handleGroupSelect,
                                        groups: this.state.groups,
                                        selectedGroup: selectedGroup
                                    })
                                ) : null
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: { marginTop: 50 } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { style: { display: 'flex', flexDirection: 'column' } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["g" /* FormControlLabel */], {
                                        control: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["o" /* Radio */], {
                                            value: '1',
                                            color: 'primary',
                                            onChange: handleSelectTypeChange,
                                            checked: selectType === "1"
                                        }),
                                        label: 'Create a new Team'
                                    }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                                        onClick: function onClick() {
                                            return handleSelectTypeByClick("1");
                                        },
                                        className: 'step2-input',
                                        defaultValue: createGroupName,
                                        ref: function ref(_ref2) {
                                            return _this2.createGroupRef = _ref2;
                                        }
                                    })
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'step2-button-container' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["a" /* Button */],
                                { variant: 'outlined',
                                    color: 'primary',
                                    onClick: this.logoutHandler
                                },
                                'Sign Out'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["a" /* Button */],
                                {
                                    onClick: function onClick() {
                                        return onStep2Click(selectType, _this2.createGroupRef.value);
                                    },
                                    variant: 'contained',
                                    color: 'primary',
                                    value: 'Next'
                                },
                                'Next'
                            )
                        )
                    ) : null,
                    this.state.getGroupsErrorMessage ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'step2-getGroupsErrorWrapper' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["t" /* Typography */],
                            null,
                            this.state.getGroupsErrorMessage
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'step2-button-container' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["a" /* Button */],
                                { variant: 'outlined',
                                    color: 'primary',
                                    onClick: this.logoutHandler
                                },
                                'Sign Out'
                            )
                        )
                    ) : null
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'step2-getGroupsErrorWrapper' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["t" /* Typography */],
                            null,
                            'one moment please..'
                        )
                    )
                )
            );
        }
    }]);

    return Step2;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(_ref3) {
    var user = _ref3.user;
    return { user: user };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(Step2));

/***/ }),

/***/ 921:
/*!*********************************************************!*\
  !*** ./src/containers/widget/components/TestSelect4.js ***!
  \*********************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Input__ = __webpack_require__(/*! @material-ui/core/Input */ 108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_InputLabel__ = __webpack_require__(/*! @material-ui/core/InputLabel */ 173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core__ = __webpack_require__(/*! @material-ui/core */ 66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__ = __webpack_require__(/*! @material-ui/core/styles/withStyles */ 922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormHelperText__ = __webpack_require__(/*! @material-ui/core/FormHelperText */ 171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormControl__ = __webpack_require__(/*! @material-ui/core/FormControl */ 123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(/*! @material-ui/core/styles */ 368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(/*! react-redux */ 47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ImgNoFound__ = __webpack_require__(/*! ./ImgNoFound */ 944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__(/*! axios */ 99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var theme1 = Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["a" /* createMuiTheme */])({
  overrides: {
    MuiSelect: {
      select: {
        "&:focus": {
          background: "$labelcolor"
        }
      }
    }
  }
});

var TestSelect4 = function (_Component) {
  _inherits(TestSelect4, _Component);

  function TestSelect4() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TestSelect4);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TestSelect4.__proto__ || Object.getPrototypeOf(TestSelect4)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      groupId: '',
      groups: []
    }, _this.handleChange = function (event) {
      var groups = _this.props.groups;

      var selectedGroup = [{ name: '' }];
      if (event.target.value != '') {
        selectedGroup = groups.filter(function (gr) {
          return gr.id === event.target.value;
        });
      }
      _this.setState({ groupId: event.target.value });
      var email = _this.props.user.email;

      var data = {
        email: email,
        // domain: '',
        id: event.target.value,
        groupName: selectedGroup[0].name
        // console.log(data)
      };_this.props.onGroupSend(data);
    }, _this.componentDidMount = function () {
      var selectedGroup = _this.props.selectedGroup;

      if (selectedGroup) {
        _this.setState({ groupId: selectedGroup.id });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TestSelect4, [{
    key: 'render',
    value: function render() {
      var groups = this.props.groups;

      groups.sort(function (a, b) {
        return a.name > b.name ? 1 : -1;
      });
      var classes = this.props.classes;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        groups ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__material_ui_core__["p" /* Select */],
            {
              className: 'select-mu',
              value: this.state.groupId
              // name='asdads'
              , onChange: this.handleChange,
              displayEmpty: true,
              disableUnderline: true,
              variant: 'outlined',
              classes: {
                root: classes.root
              },
              MenuProps: MenuProps
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3__material_ui_core__["n" /* MenuItem */],
              { value: '' },
              'None'
            ),
            groups.map(function (group) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3__material_ui_core__["n" /* MenuItem */],
                {
                  value: group.id,
                  key: group.id
                },
                group.img ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'select-img', src: group.img }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ImgNoFound__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3__material_ui_core__["t" /* Typography */],
                  { variant: 'body1', style: { marginLeft: 10 } },
                  group.name
                ),
                group.type === 'public channel' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3__material_ui_core__["t" /* Typography */],
                  { style: {
                      marginLeft: 5,
                      color: 'grey'
                    } },
                  '(Channel)'
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3__material_ui_core__["t" /* Typography */],
                  { style: {
                      marginLeft: 5,
                      color: 'grey'
                    } },
                  '(',
                  group.members && group.members.length,
                  ' members)'
                )
              );
            })
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          'No Groups'
        )
      );
    }
  }]);

  return TestSelect4;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(_ref2) {
  var user = _ref2.user;
  return { user: user };
};

var style = {
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    border: '1px solid lightgrey',
    borderRadius: 7,
    minHeight: 53,
    padding: '0 20px'
  }
};

var MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 250
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_withStyles___default()(style)(TestSelect4)));

/***/ }),

/***/ 944:
/*!********************************************************!*\
  !*** ./src/containers/widget/components/ImgNoFound.js ***!
  \********************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TestBinaryData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function TestBinaryData() {
    var data = 'data:image/jpeg;base64,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';
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'select-img', src: data
    });
}

/***/ }),

/***/ 945:
/*!*********************************************************!*\
  !*** ./src/containers/widget/components/Steps/Step3.js ***!
  \*********************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(/*! @material-ui/core */ 66);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Step3 = function (_Component) {
    _inherits(Step3, _Component);

    function Step3() {
        _classCallCheck(this, Step3);

        return _possibleConstructorReturn(this, (Step3.__proto__ || Object.getPrototypeOf(Step3)).apply(this, arguments));
    }

    _createClass(Step3, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                handleBack = _props.handleBack,
                BackFromWidget = _props.BackFromWidget,
                onCreateWidget = _props.onCreateWidget,
                widget = _props.widget,
                onShowWidget = _props.onShowWidget,
                focused = _props.focused,
                deliveryMethod = _props.deliveryMethod,
                handleDeliveryMethodChange = _props.handleDeliveryMethodChange;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'step3-wrapper' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'step3-main-view' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["t" /* Typography */],
                        { variant: 'h5' },
                        'You\'re Almost Done'
                    ),
                    widget === '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["t" /* Typography */],
                            { style: {
                                    textAlign: 'left',
                                    marginTop: 10
                                } },
                            'How visitors on your website interact with you using the Messaging Bridge Widget:'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'step3-radio-wrapper' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["g" /* FormControlLabel */], {
                                style: { margin: 0 },
                                control: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["o" /* Radio */], {
                                    value: '1',
                                    color: 'primary',
                                    onChange: handleDeliveryMethodChange,
                                    checked: deliveryMethod === "1"
                                }),
                                label: 'Message from website (Anonymous Email)'
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["g" /* FormControlLabel */], {
                                style: { margin: 0 },
                                control: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["o" /* Radio */], {
                                    value: '3',
                                    color: 'primary',
                                    onChange: handleDeliveryMethodChange,
                                    checked: deliveryMethod === "3"
                                }),
                                label: 'Message from website (Real Email)'
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["g" /* FormControlLabel */], {
                                style: { margin: 0 },
                                control: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["o" /* Radio */], {
                                    value: '2',
                                    color: 'primary',
                                    onChange: handleDeliveryMethodChange,
                                    checked: deliveryMethod === "2"
                                }),
                                label: 'Default email client (Anonymous Email)'
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: focused, ref: function ref(_ref) {
                                    return _this2.usersUrlInput = _ref;
                                }, className: 'step3-input', style: { width: '100%' }, placeholder: 'Enter your website URL' })
                        )
                    ) : null
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'step3-buttons-wrapper' },
                    widget === '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["a" /* Button */],
                            {
                                variant: 'outlined',
                                color: 'primary',
                                style: { width: 156 },
                                onClick: handleBack
                            },
                            'back'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["a" /* Button */],
                            {
                                variant: 'contained',
                                color: 'primary',
                                onClick: function onClick() {
                                    return onCreateWidget(_this2.usersUrlInput.value);
                                },
                                style: { width: 156 }
                            },
                            'Create'
                        )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["a" /* Button */],
                            {
                                variant: 'outlined',
                                color: 'primary',
                                style: { width: 156 },
                                onClick: BackFromWidget
                            },
                            'Cancel'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["a" /* Button */],
                            {
                                variant: 'contained',
                                color: 'primary',
                                onClick: onShowWidget,
                                style: { width: 156 }
                            },
                            'Show Widget'
                        )
                    )
                )
            );
        }
    }]);

    return Step3;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Step3);

/***/ }),

/***/ 946:
/*!***************************************************************!*\
  !*** ./src/containers/widget/components/Steps/FormCreator.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(/*! @material-ui/core */ 66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormCreator_AddFieldForm__ = __webpack_require__(/*! ./FormCreator/AddFieldForm */ 947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_jsonschema_form__ = __webpack_require__(/*! react-jsonschema-form */ 499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_jsonschema_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_jsonschema_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__(/*! bootstrap/dist/css/bootstrap.min.css */ 497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_js_bootstrap_min_js__ = __webpack_require__(/*! bootstrap/dist/js/bootstrap.min.js */ 498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_js_bootstrap_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_js_bootstrap_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Delete__ = __webpack_require__(/*! @material-ui/icons/Delete */ 1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Edit__ = __webpack_require__(/*! @material-ui/icons/Edit */ 1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Reorder__ = __webpack_require__(/*! @material-ui/icons/Reorder */ 1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Reorder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Reorder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FormCreator_Templates__ = __webpack_require__(/*! ./FormCreator/Templates */ 1187);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var FormCreator = function (_Component) {
    _inherits(FormCreator, _Component);

    function FormCreator() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, FormCreator);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FormCreator.__proto__ || Object.getPrototypeOf(FormCreator)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            //schema
            fieldToEdit: '',
            title: "Form title",
            description: "Form description",
            type: "object",
            required: [],
            properties: {},
            uiSchema: {},
            //internal
            addFieldDialog: false,
            isTemplate: true
        }, _this.toggleAddFieldDialog = function () {
            _this.setState(function (prevState) {
                return {
                    addFieldDialog: !prevState.addFieldDialog
                };
            });
        }, _this.jsonCopy = function (src) {
            return JSON.parse(JSON.stringify(src));
        }, _this.resetFieldToEdit = function () {
            _this.setState({ fieldToEdit: '' });
        }, _this.setValue = function (key, e) {
            var _this2;

            var schema = _this.state;
            var value = e.target.value;
            schema[key] = value;
            (_this2 = _this).setState.apply(_this2, _toConsumableArray(schema).concat([{ key: value }]));
        }, _this.handleDelete = function (id) {
            var _this$state = _this.state,
                properties = _this$state.properties,
                required = _this$state.required,
                uiSchema = _this$state.uiSchema;

            delete properties[id];
            if (required.includes(id)) {
                required = required.filter(function (element) {
                    return element !== id;
                });
            }
            if (uiSchema[id]) {
                delete uiSchema[id];
            }
            _this.setState({ properties: properties, required: required, uiSchema: uiSchema });
        }, _this.handleEdit = function (fieldToEdit) {
            _this.setState({ fieldToEdit: fieldToEdit }, function () {
                _this.toggleAddFieldDialog();
            });
        }, _this.onAdd = function (values) {
            var isRequired = values.isRequired,
                id = values.id,
                rows = values.rows,
                options = values.options,
                enumType = values.enumType,
                maximum = values.maximum,
                minimum = values.minimum,
                type = values.type;
            var _this$state2 = _this.state,
                required = _this$state2.required,
                properties = _this$state2.properties,
                uiSchema = _this$state2.uiSchema;


            if (rows > 1) {
                uiSchema[id] = {
                    "ui:widget": "textarea",
                    "ui:options": {
                        rows: Number(rows)
                    }
                };
            }

            if (options && options.length > 0 && enumType === 'radio') {
                uiSchema[id] = {
                    "ui:widget": enumType,
                    "ui:options": {
                        inline: false
                    }
                };
            }

            if (type === 'integer') {
                if (!maximum) {
                    delete values['maximum'];
                }
                if (!minimum) {
                    delete values['minimum'];
                }
            }

            if (isRequired) {
                required.push(id);
            }
            properties[id] = Object.assign({}, values, {
                enum: options,
                default: ''
            });
            _this.setState({ properties: properties, required: required, uiSchema: uiSchema }, function () {
                console.warn(_this.state);
                _this.toggleAddFieldDialog();
            });
        }, _this.onUpdate = function (field) {
            var properties = _this.state.properties;

            properties[field.id] = Object.assign({}, properties[field.id], field);
            _this.setState({ properties: properties }, function () {
                _this.toggleAddFieldDialog();
            });
        }, _this.getFieldType = function (type) {
            switch (type) {
                case 'string':
                    return 'Text';
                case 'integer':
                    return 'Number';
                case 'textarea':
                    return 'Multiline text';
                case 'select':
                    return 'Drop down';
                default:
                    return type;
            }
        }, _this.templateToggler = function (e) {
            var value = e.target.value;
            var isTemplate = true;
            var template = void 0;
            switch (value) {
                case 'custom':
                    template = _this.jsonCopy(__WEBPACK_IMPORTED_MODULE_9__FormCreator_Templates__["a" /* initial */]);
                    isTemplate = false;
                    break;
                case 'template1':
                    template = _this.jsonCopy(__WEBPACK_IMPORTED_MODULE_9__FormCreator_Templates__["b" /* template1 */]);
                    break;
                case 'template2':
                    template = _this.jsonCopy(__WEBPACK_IMPORTED_MODULE_9__FormCreator_Templates__["c" /* template2 */]);
                    break;
                case 'template3':
                    template = _this.jsonCopy(__WEBPACK_IMPORTED_MODULE_9__FormCreator_Templates__["d" /* template3 */]);
                    break;
                default:
                    break;
            }
            _this.setState(Object.assign({ isTemplate: isTemplate }, template));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(FormCreator, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var template = this.jsonCopy(__WEBPACK_IMPORTED_MODULE_9__FormCreator_Templates__["b" /* template1 */]);
            this.setState(Object.assign({}, template));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var handleNext = this.props.handleNext;
            var _state = this.state,
                addFieldDialog = _state.addFieldDialog,
                fieldToEdit = _state.fieldToEdit,
                isTemplate = _state.isTemplate;

            var properties = Object.values(this.state.properties);

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'creator-container' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'creator-item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["t" /* Typography */],
                        { style: { fontWeight: 600 } },
                        'Builder'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { width: '100%', display: 'flex', flexDirection: 'column', height: '100%' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'fieldset',
                            { id: 'root' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'form-group field' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'label',
                                    null,
                                    'Template'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'select',
                                    {
                                        onChange: this.templateToggler,
                                        name: 'type',
                                        className: 'form-control'
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'option',
                                        { value: 'template1' },
                                        'Template #1'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'option',
                                        { value: 'template2' },
                                        'Template #2'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'option',
                                        { value: 'template3' },
                                        'Template #3'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'option',
                                        { value: 'custom' },
                                        'Custom'
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'form-group field field-string' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'label',
                                    { className: 'control-label', htmlFor: 'builder-title' },
                                    'Form Title'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onChange: function onChange(e) {
                                        return _this3.setValue('title', e);
                                    }, className: 'form-control', id: 'builder-title', label: 'Form Title', placeholder: '', value: this.state.title, type: 'text' })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'form-group field field-string' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'label',
                                    { className: 'control-label', htmlFor: 'builder-title' },
                                    'Form Description'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onChange: function onChange(e) {
                                        return _this3.setValue('description', e);
                                    }, className: 'form-control', id: 'builder-title', label: 'Form Title', placeholder: '', value: this.state.description, type: 'text' })
                            )
                        ),
                        !isTemplate && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["t" /* Typography */],
                                { style: { fontWeight: 600, textAlign: 'center' } },
                                'Fields'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["j" /* List */],
                                { style: { maxHeight: 400, overflow: 'auto', margin: '10px 0' } },
                                properties.map(function (field, index) {
                                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["k" /* ListItem */],
                                        {
                                            key: index,
                                            divider: index !== properties.length - 1,
                                            style: { paddingTop: 0, paddingBottom: 0 }
                                        },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["m" /* ListItemText */], {
                                            secondaryTypographyProps: { style: { textTransform: 'capitalize' } },
                                            primary: field.title,
                                            secondary: _this3.getFieldType(field.origType)
                                        }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["l" /* ListItemSecondaryAction */],
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["i" /* IconButton */],
                                                { onClick: function onClick() {
                                                        return _this3.handleDelete(field.id);
                                                    } },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_Delete___default.a, { style: { fontSize: 16 } })
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["i" /* IconButton */],
                                                { onClick: function onClick() {
                                                        return _this3.handleEdit(field);
                                                    } },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Edit___default.a, { style: { fontSize: 16 } })
                                            )
                                        )
                                    );
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["a" /* Button */],
                                {
                                    onClick: this.toggleAddFieldDialog,
                                    variant: 'outlined',
                                    color: 'primary',
                                    fullWidth: true,
                                    disabled: isTemplate
                                },
                                'Add Field'
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'creator-item' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["t" /* Typography */],
                        { style: { fontWeight: 600 } },
                        'Preview'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { overflow: 'auto', width: '100%', flexGrow: 1, padding: '0 15px' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_jsonschema_form___default.a, {
                            schema: this.state,
                            uiSchema: this.state.uiSchema
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { width: '100%', textAlign: 'end' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["a" /* Button */],
                            {
                                onClick: function onClick() {
                                    return handleNext(_this3.state);
                                },
                                variant: 'contained',
                                color: 'primary',
                                fullWidth: true
                            },
                            'Next'
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["c" /* Dialog */],
                    {
                        open: addFieldDialog,
                        onClose: this.toggleAddFieldDialog
                    },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["e" /* DialogTitle */],
                        null,
                        'Add Field'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["d" /* DialogContent */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FormCreator_AddFieldForm__["a" /* default */], {
                            onAdd: this.onAdd,
                            fieldToEdit: fieldToEdit,
                            resetFieldToEdit: this.resetFieldToEdit,
                            onUpdate: this.onUpdate
                        })
                    )
                )
            );
        }
    }]);

    return FormCreator;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (FormCreator);

/***/ }),

/***/ 947:
/*!****************************************************************************!*\
  !*** ./src/containers/widget/components/Steps/FormCreator/AddFieldForm.js ***!
  \****************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(/*! react */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(/*! @material-ui/core */ 66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Add__ = __webpack_require__(/*! @material-ui/icons/Add */ 948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Remove__ = __webpack_require__(/*! @material-ui/icons/Remove */ 950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Remove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Remove__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__(/*! bootstrap/dist/css/bootstrap.min.css */ 497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_js_bootstrap_min_js__ = __webpack_require__(/*! bootstrap/dist/js/bootstrap.min.js */ 498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_js_bootstrap_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_js_bootstrap_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uuid_v4__ = __webpack_require__(/*! uuid/v4 */ 951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uuid_v4__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var AddFieldForm = function (_Component) {
    _inherits(AddFieldForm, _Component);

    function AddFieldForm(props) {
        _classCallCheck(this, AddFieldForm);

        var _this = _possibleConstructorReturn(this, (AddFieldForm.__proto__ || Object.getPrototypeOf(AddFieldForm)).call(this, props));

        _initialiseProps.call(_this);

        var fieldToEdit = props.fieldToEdit !== '';
        _this.state = {
            isUpdate: fieldToEdit,
            selectedType: '',
            options: ['', '']
        };
        return _this;
    }

    _createClass(AddFieldForm, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var isUpdate = this.state.isUpdate;

            if (isUpdate) {
                this.props.resetFieldToEdit();
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var isUpdate = this.state.isUpdate;
            var fieldToEdit = this.props.fieldToEdit;

            if (isUpdate) {
                this.inputTitle.value = fieldToEdit.title;
                this.inputType.value = fieldToEdit.type;
                this.inputCheckBox.checked = fieldToEdit.isRequired;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this,
                _React$createElement;

            var _state = this.state,
                isUpdate = _state.isUpdate,
                selectedType = _state.selectedType,
                options = _state.options;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'form',
                { onSubmit: this.onSubmit },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group field field-string' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        { className: 'control-label' },
                        'Field Label'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                        ref: function ref(_ref) {
                            return _this2.inputTitle = _ref;
                        },
                        className: 'form-control',
                        label: 'Form Title',
                        placeholder: '',
                        type: 'text',
                        name: 'label',
                        required: true
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group field' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        'Field Type'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'select',
                        { name: 'type', onChange: this.onTypeChange, ref: function ref(_ref2) {
                                return _this2.inputType = _ref2;
                            }, className: 'form-control' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'option',
                            { value: 'string' },
                            'Text'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'option',
                            { value: 'textarea' },
                            'Multi line text'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'option',
                            { value: 'integer' },
                            'Number'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'option',
                            { value: 'select' },
                            'Select'
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["b" /* Collapse */],
                    { 'in': selectedType === 'textarea' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'form-group field' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'label',
                            null,
                            'Number of rows'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'select',
                            { name: 'rows', ref: function ref(_ref3) {
                                    return _this2.inputRows = _ref3;
                                }, className: 'form-control' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'option',
                                { value: '2' },
                                '2'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'option',
                                { value: '3' },
                                '3'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'option',
                                { value: '4' },
                                '4'
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["b" /* Collapse */],
                    { 'in': selectedType === 'integer' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'form-group field' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'label',
                            null,
                            'Minimum'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                            className: 'form-control',
                            placeholder: '',
                            type: 'number',
                            name: 'minimum'
                        })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'form-group field' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'label',
                            null,
                            'Maximum'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                            className: 'form-control',
                            placeholder: '',
                            type: 'number',
                            name: 'maximum'
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["b" /* Collapse */],
                    { 'in': selectedType === 'select' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'form-group field' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'label',
                            null,
                            'Select Type'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'select',
                            (_React$createElement = { name: 'rows' }, _defineProperty(_React$createElement, 'name', 'select-type'), _defineProperty(_React$createElement, 'className', 'form-control'), _React$createElement),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'option',
                                { value: 'dropdown' },
                                'Drop down'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'option',
                                { value: 'radio' },
                                'Radio buttons'
                            )
                        )
                    ),
                    options.map(function (option, index) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { key: index, className: 'form-group field' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'label',
                                null,
                                'Option #' + (index + 1)
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                                className: 'form-control',
                                type: 'text',
                                value: option,
                                onChange: function onChange(e) {
                                    return _this2.handleOptionChange(e, index);
                                }
                            })
                        );
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-6 text-center' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["i" /* IconButton */],
                                { onClick: this.handleOptionAdd, style: { outline: 'none' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Add___default.a, { style: { fontSize: 16 } })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-6 text-center' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1__material_ui_core__["i" /* IconButton */],
                                { disabled: options.length < 3, onClick: this.handleOptionRemove, style: { outline: 'none' } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Remove___default.a, { style: { fontSize: 16 } })
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group field field-string mt-3' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'input-group mb-3' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'input-group-prepend' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { name: 'isRequired', ref: function ref(_ref4) {
                                        return _this2.inputCheckBox = _ref4;
                                    }, type: 'checkbox', 'aria-label': 'Checkbox for following text input' })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: 'ml-2' },
                            'Required'
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    {
                        type: 'submit',
                        className: 'btn w-100',
                        style: { backgroundColor: '#3f51b5', color: '#fff' }
                    },
                    isUpdate ? 'Update Field' : 'Add Field'
                )
            );
        }
    }]);

    return AddFieldForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.onSubmit = function (e) {
        e.preventDefault();
        var _state2 = _this3.state,
            isUpdate = _state2.isUpdate,
            options = _state2.options;
        var fieldToEdit = _this3.props.fieldToEdit;

        var title = e.target['label'].value;
        var isRequired = e.target['isRequired'].checked;
        var type = e.target['type'].value;
        var enumType = e.target['select-type'].value;
        var minimum = Number(e.target['minimum'].value);
        var maximum = Number(e.target['maximum'].value);

        var rows = 1;
        options = options.filter(function (option) {
            return option !== '';
        });
        var origType = type;
        switch (type) {
            case 'textarea':
                type = 'string';
                rows = _this3.inputRows.value;
                options = undefined;
                break;
            case 'select':
                type = 'string';
                break;
            default:
                options = undefined;
                break;
        }

        if (isUpdate) {
            _this3.props.onUpdate(Object.assign({}, fieldToEdit, {
                title: title,
                type: type,
                isRequired: isRequired,
                rows: rows,
                options: options,
                enumType: enumType,
                minimum: minimum,
                maximum: maximum,
                origType: origType
            }));
        } else {
            _this3.props.onAdd({
                id: __WEBPACK_IMPORTED_MODULE_6_uuid_v4___default()(),
                title: title,
                type: type,
                isRequired: isRequired,
                rows: rows,
                options: options,
                enumType: enumType,
                minimum: minimum,
                maximum: maximum,
                origType: origType
            });
        }
        _this3.setState({
            selectedType: '',
            options: ['', '']
        });
    };

    this.onTypeChange = function (e) {
        var selectedType = _this3.inputType.value;
        _this3.setState({ selectedType: selectedType });
    };

    this.renderOption = function (index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-group field' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Option #' + index
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                className: 'form-control',
                type: 'text'
            })
        );
    };

    this.handleOptionChange = function (e, index) {
        var options = _this3.state.options;

        options[index] = e.target.value;
        _this3.setState({ options: options });
    };

    this.handleOptionAdd = function () {
        var options = _this3.state.options;

        options.push('');
        _this3.setState({ options: options });
    };

    this.handleOptionRemove = function () {
        var options = _this3.state.options;

        options.pop();
        _this3.setState({ options: options });
    };
};

/* harmony default export */ __webpack_exports__["a"] = (AddFieldForm);

/***/ })

},[628]);


// WEBPACK FOOTER //
// client.bundle.js